import React from 'react';

export const Whoops404: React.FC = () => {
  return <div className="permission_denied">404 - PAGE NOT FOUND</div>;
};
